export default __webpack_public_path__ + "static/media/bannerLogo.2d995b24.png";